import {
  Pin,
  PinOff,
  Lock,
  Unlock,
  Trash2,
  Flag,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Button, toast } from "../ui";
import { discussionsApi, errMessage } from "./api";

/**
 * Topic-level moderator controls (admin shell only — `isAdmin` from App.js;
 * the server also hard-enforces `require_moderator`). Pin/unpin, close/reopen,
 * soft-delete the topic. Per-message moderation (delete / report) lives on the
 * message bubble's hover actions.
 */
export default function ModerationBar({ topic, onChanged, onDeleted }) {
  if (!topic) return null;
  const closed = topic.status === "CLOSED";
  const pinned = !!topic.is_pinned;

  const run = async (fn, okMsg) => {
    try {
      const res = await fn();
      if (okMsg) toast.success(okMsg);
      if (onChanged) onChanged(res);
    } catch (e) {
      toast.error(errMessage(e));
    }
  };

  const del = async () => {
    if (!window.confirm("Delete this topic for everyone? This cannot be undone.")) return;
    try {
      await discussionsApi.deleteTopic(topic.id);
      toast.success("Topic deleted.");
      if (onDeleted) onDeleted();
    } catch (e) {
      toast.error(errMessage(e));
    }
  };

  return (
    <div className="vdsc-modbar">
      <span className="vdsc-modbar-label">Moderator</span>
      <Button
        variant="secondary"
        size="sm"
        leftIcon={pinned ? <PinOff size={14} /> : <Pin size={14} />}
        onClick={() =>
          run(
            () =>
              pinned
                ? discussionsApi.unpinTopic(topic.id)
                : discussionsApi.pinTopic(topic.id),
            pinned ? "Unpinned." : "Pinned."
          )
        }
      >
        {pinned ? "Unpin" : "Pin"}
      </Button>
      <Button
        variant="secondary"
        size="sm"
        leftIcon={closed ? <Unlock size={14} /> : <Lock size={14} />}
        onClick={() =>
          run(
            () =>
              closed
                ? discussionsApi.reopenTopic(topic.id)
                : discussionsApi.closeTopic(topic.id),
            closed ? "Reopened." : "Closed — now read-only."
          )
        }
      >
        {closed ? "Reopen" : "Close"}
      </Button>
      <Button
        variant="secondary"
        size="sm"
        className="vdsc-modbar-danger"
        leftIcon={<Trash2 size={14} />}
        onClick={del}
      >
        Delete topic
      </Button>
      <Link to="/discussions/reports" className="vdsc-modbar-reports">
        <Flag size={13} /> Report queue
      </Link>
    </div>
  );
}
